<template>
  <div class="w-h6 page-title mt-2 mb-8" :class="{' text--darken-1': !no_color}" @click="$emit('click')" data-test-id="page-title">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    'no_color': {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data() {
    return {};
  },
};
</script>
<style>
  .page-title {
    letter-spacing: -0.2px !important; 
    padding: 15px;
    border-color: #e0e0e0;
    border-style: solid;
    border-width: 0 0 1px 0;
    background-color: #f5f5f5; 
        position: absolute !important;
    top: -8px;
    width: 100%;
    margin: 0px !important;
    left: 0px;
    color: #1A1A1A !important;
  }
</style>
